

import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { NavLink as RouterLink, matchPath, useLocation, useParams } from 'react-router-dom';
// material
import { alpha, useTheme, styled } from '@mui/material/styles';
import { Box, List, Collapse, ListItemText, ListItemIcon, ListItemButton, Divider } from '@mui/material';
//
import { doc, getDoc } from 'firebase/firestore';
import Iconify from './Iconify';
import { db } from '../firebase.config';
import { NavItem } from './navItem';

// ----------------------------------------------------------------------

const ListItemStyle = styled((props) => <ListItemButton disableGutters {...props} />)(({ theme }) => ({
  ...theme.typography.body2,
  height: 48,
  position: 'relative',
  textTransform: 'capitalize',
  color: 'text.secondary',
  fontSize: '16px',
  borderRadius: '7px',
}));

const ListTitleStyle = styled((props) => <ListItemButton disableGutters {...props} />)(({ theme }) => ({
  ...theme.typography.body2,
  height: 48,
  position: 'relative',
  textTransform: 'uppercase',
  color: 'white',
  fontWeight: 'bold',
  borderRadius: theme.shape.borderRadius,
}));

const ListItemIconStyle = styled(ListItemIcon)({
  width: 22,
  height: 22,
  color: 'inherit',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

// ----------------------------------------------------------------------



NavSectionMetrics.propTypes = {
  navConfig: PropTypes.array,
};

export default function NavSectionMetrics({ navConfig, onCloseSidebar, isDesktop }) {

  const { pathname } = useLocation();

  const { eventID } = useParams();
  const [seance, isSeance] = useState(false)
  useEffect(() => {
    (async () => {
      try {
        // event
        if (!eventID) {
          return;
        }
        const docRef0 = doc(db, 'evenement', eventID);
        const docSnap = await getDoc(docRef0);
        if (docSnap.exists()) {
          console.info(docSnap.data().seanceActive);
          if (docSnap.data().seanceActive === 1) {
            isSeance(true)
          } else {
            isSeance(false)
          }
        }

        // console.error(navConfig)
      } catch (error) {
        console.log(error);
      }
    })();
  }, [eventID]);

  return (
    <List disablePadding sx={{ p: 1 }}>
      {navConfig.map((item) => (
        item.title ==="Seances" && !seance ? null :
        <NavItem key={item.title} item={item} onCloseSidebar={onCloseSidebar}
          isDesktop={isDesktop} />
      ))}
    </List>
  );
}
